export default __webpack_public_path__ + "static/media/Legend9.562b2828.jpeg";